module.exports = __webpack_public_path__ + "img/report_background_one.2583ed58.png";